import React from "react";
import { useTranslation } from "react-i18next";
import "./QdsSignModal.style.css";

interface QdsSignInstructionsProps {
  qdsRequestId?: number;
  email?: string;
  token?: string;
  documentName?: string;
  onDownload?: () => void;
}

export const QdsSignInstructions: React.FC<QdsSignInstructionsProps> = ({ 
  qdsRequestId,
  email,
  token,
  documentName,
  onDownload 
}) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    if (onDownload) {
      onDownload();
    }
  };

  return (
    <div className="qds-sign-instructions">
      <h3 className="qds-instructions-header">{t("WEB_QDS_SIGNATURE.STEPS_TO_SIGN_DOCUMENT")}</h3>
      <div className="qds-instructions-content">
        <div className="qds-instruction-step">
          <div className="qds-step-number">1</div>
          <div className="qds-step-content">
            <h4>{t("WEB_QDS_SIGNATURE.DOWNLOAD_DOCUMENT_TITLE")}</h4>
            <p>
              {t("WEB_QDS_SIGNATURE.DOWNLOAD_DOCUMENT_DESC")}
            </p>
            <button className="qds-download-button" onClick={handleDownload}>
              {t("WEB_QDS_SIGNATURE.DOWNLOAD_BUTTON")}
            </button>
          </div>
        </div>

        <div className="qds-instruction-step">
          <div className="qds-step-number">2</div>
          <div className="qds-step-content">
            <h4>{t("WEB_QDS_SIGNATURE.SIGN_OFFLINE_TITLE")}</h4>
            <p>
              {t("WEB_QDS_SIGNATURE.SIGN_OFFLINE_DESC")}
            </p>
          </div>
        </div>

        <div className="qds-instruction-step">
          <div className="qds-step-number">3</div>
          <div className="qds-step-content">
            <h4>{t("WEB_QDS_SIGNATURE.UPLOAD_SIGNED_TITLE")}</h4>
            <p>
              {t("WEB_QDS_SIGNATURE.UPLOAD_SIGNED_DESC")}
            </p>
          </div>
        </div>

        <div className="qds-instruction-step">
          <div className="qds-step-number">4</div>
          <div className="qds-step-content">
            <h4>{t("WEB_QDS_SIGNATURE.CONFIRM_SIGNATURE_TITLE")}</h4>
            <p>{t("WEB_QDS_SIGNATURE.CONFIRM_SIGNATURE_DESC")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
